/*global define*/

define(function () {
    'use strict';

    function stripTags() {
        return function (input) {
            return input.replace(/(<([^>]+)>)/ig, '');
        };
    }

    stripTags.$inject = [];

    return stripTags;
});



/** WEBPACK FOOTER **
 ** ./~/ng-annotate-loader/loader.js!./src/javascripts/ng-admin/Main/component/filter/StripTags.js
 **/